(function () {
  "use strict";
  if (window.__heroProductJsInitialized) { return; }
  window.__heroProductJsInitialized = true;

  function initFaq(root) {
    var items = root.querySelectorAll(".hp-faq-question");
    items.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var expanded = btn.getAttribute("aria-expanded") === "true";
        var answer = document.getElementById(btn.getAttribute("aria-controls"));
        btn.setAttribute("aria-expanded", String(!expanded));
        if (answer) {
          answer.style.maxHeight = expanded ? null : answer.scrollHeight + "px";
        }
      });
    });
  }

  function initStickyCta(bar) {
    var buyBox = document.querySelector(".formAddToCart");
    var scrollBtn = bar.querySelector("[data-hp-scroll-to-buybox]");
    var priceEl = bar.querySelector("[data-hp-sticky-price]");
    var sourcePrice = document.getElementById("ProductPrice");

    if (scrollBtn && buyBox) {
      scrollBtn.addEventListener("click", function () {
        buyBox.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    }

    if (priceEl && sourcePrice) {
      priceEl.textContent = sourcePrice.textContent.trim();
      if (window.MutationObserver) {
        new MutationObserver(function () {
          priceEl.textContent = sourcePrice.textContent.trim();
        }).observe(sourcePrice, { childList: true, characterData: true, subtree: true });
      }
    }

    if (buyBox) {
      var updateVisibility = function () {
        var rect = buyBox.getBoundingClientRect();
        var outOfView = rect.bottom < 0 || rect.top > window.innerHeight;
        bar.classList.toggle("is-visible", outOfView);
      };

      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              bar.classList.toggle("is-visible", !entry.isIntersecting);
            });
          },
          { threshold: 0 }
        );
        io.observe(buyBox);
      }

      window.addEventListener("scroll", updateVisibility, { passive: true });
      window.addEventListener("resize", updateVisibility, { passive: true });
      updateVisibility();
    }
  }

  function initVideo(wrap) {
    var trigger = wrap.querySelector("[data-hp-video-trigger]");
    if (!trigger) return;
    trigger.addEventListener("click", function () {
      var embedHtml = trigger.getAttribute("data-embed");
      if (embedHtml) {
        wrap.innerHTML = embedHtml;
      }
      if (typeof gtag === "function") {
        gtag("event", "video_play", {
          video_title: document.title,
          page_location: window.location.href
        });
      }
    });
  }

  function initCrossSells(grid) {
    var cards = grid.querySelectorAll(".hp-cross-card");
    cards.forEach(function (card) {
      card.addEventListener("click", function () {
        if (typeof gtag !== "function") return;
        var titleEl = card.querySelector(".hp-cross-card__title");
        gtag("event", "select_item", {
          item_list_name: "hero_accessories",
          items: [{
            item_name: titleEl ? titleEl.textContent.trim() : undefined
          }]
        });
      });
    });
  }

  function initComboSelector(root) {
    var select = root.querySelector("[data-hp-combo-select]");
    var img = root.querySelector("[data-hp-combo-image]");
    var priceEl = root.querySelector("[data-hp-combo-price]");
    var btn = root.querySelector("[data-hp-combo-add]");
    var status = root.querySelector("[data-hp-combo-status]");
    if (!select || !btn) return;

    function syncFromSelection() {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      if (priceEl) priceEl.textContent = opt.getAttribute("data-price");
      if (img && opt.getAttribute("data-image")) img.src = opt.getAttribute("data-image");
    }

    select.addEventListener("change", syncFromSelection);
    syncFromSelection();

    btn.addEventListener("click", function () {
      var variantId = select.value;
      if (!variantId) return;
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = "Adding...";
      if (status) status.textContent = "";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error("add failed");
          return res.json();
        })
        .then(function () {
          window.location.href = "/cart";
        })
        .catch(function () {
          btn.textContent = originalText;
          btn.disabled = false;
          if (status) status.textContent = "Something went wrong — please try again or use the button above.";
        });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-hp-faq]").forEach(initFaq);
    document.querySelectorAll("[data-hp-sticky-cta]").forEach(initStickyCta);
    document.querySelectorAll("[data-hp-video]").forEach(initVideo);
    document.querySelectorAll(".hp-cross-grid").forEach(initCrossSells);
    document.querySelectorAll("[data-hp-combo]").forEach(initComboSelector);
  });
})();
